export const RPC = "https://rpc.ftm.tools";
export const contractAddress = "0x5746A1ec97d91c594e6042a7A42c8285C4c3A0EE";
export const chainID = 250;